import Button from 'components/common/Button/Button';
import linuxImage from 'assets/img/logo-linux.png';
import windowsImage from 'assets/img/logo-windows.png';
import dockerImage from 'assets/img/logo-docker.png';

import * as K from 'common/constants';
import { HELP_ROUTE } from 'components/help/constants';

import './OnBoarding.scss';

/**
 * This component show on boarding information, containing some important links about getting started to the user.
 */
const OnBoarding = (): JSX.Element => (
  <div className="OnBoarding">
    <h1 className="OnBoarding__Title">Welcome to {K.PRODUCT_NAME}!</h1>
    <p className="OnBoarding__SubTitle">Let&apos;s see how fast we can get you up and running...</p>
    <p className="OnBoarding__SubTitle">
      If your logs are
      <b>on servers that you control</b> (physical or virtual), choose one of these:
    </p>

    <div className="OnBoarding__Services">
      <Button className="OnBoarding__ServiceCard" href={HELP_ROUTE.HELP_INSTALL_AGENT_LINUX_QUICK_START_1} openInNewTab>
        <img src={linuxImage} alt="Linux" />
        <br />
        <span className="OnBoarding__ServiceCardTitle">Linux</span>
      </Button>

      <Button className="OnBoarding__ServiceCard" href={HELP_ROUTE.HELP_INSTALL_AGENT_DOCKER} openInNewTab>
        <img src={dockerImage} alt="Docker" />
        <br />
        <span className="OnBoarding__ServiceCardTitle">Docker</span>
      </Button>

      <Button className="OnBoarding__ServiceCard" href={HELP_ROUTE.HELP_INSTALL_AGENT_WINDOWS} openInNewTab>
        <img src={windowsImage} alt="Windows" />
        <br />
        <span className="OnBoarding__ServiceCardTitle">Windows</span>
      </Button>
    </div>

    <div className="OnBoarding__OrContainer">
      <div className="OnBoarding__Line" role="presentation" />
      <div className="OnBoarding__Or">or</div>
      <div className="OnBoarding__Line" role="presentation" />
    </div>

    <p className="OnBoarding__SubTitle">On a managed cloud service, such as Heroku:</p>

    <Button href={HELP_ROUTE.HELP_DATA_SOURCES} openInNewTab className="OnBoarding__ExternalLink">
      Connect External Services
    </Button>
  </div>
);

export default OnBoarding;
